import React from 'react';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { Collapse, Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Portal } from '@mui/material';
import { useMutation } from 'react-fetching-library';
import { updateOrder } from '../../../../services/redux-actions';
import { deleteProductAction } from '../../../../services/request';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { ConfirmDialog } from '../../../../components/ConfirmDialog';
import EditPositionModal from './EditiPositionModa';
import toast from 'react-hot-toast';

function Row(props) {
  const { row, setPosition, setOpenConfirmDialog, setOpenEditModal, showOptions, module, order } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>

      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell align="center">{row.name}</TableCell>
        <TableCell align="center">{row.gross_value}</TableCell>
        { showOptions === true
          ? <TableCell>
            {row.name.startsWith('Transport') || (row.name === order.event_name && module === 'obozy')
              ? null
              : <IconButton
                onClick={() => {
                  setPosition(row);
                  setOpenEditModal(true);
                }}
                color="primary"
              >
                <EditIcon />
              </IconButton>}
          </TableCell>
          : null}
        { showOptions === true
          ? <TableCell>
            <IconButton
              onClick={() => {
                setPosition(row);
                setOpenConfirmDialog(true);
              }}
              color="error"
            >
              <DeleteIcon />
            </IconButton>
          </TableCell>
          : null}
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Szczegóły
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Ilość</TableCell>
                    <TableCell align="right">Netto</TableCell>
                    <TableCell align="right">Podatek</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>{row.quantity}</TableCell>
                    <TableCell align="right">{row.net_value}</TableCell>
                    <TableCell align="right">{row.vat_rate} %
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export const Positions = props => {
  const dispatch = useDispatch();
  const { formik, positions, order, module } = props;
  const { loading, mutate } = useMutation(deleteProductAction);

  const [open, setOpen] = React.useState(false);
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [position, setPosition] = React.useState(null);

  const handleDelete = async () => {
    if (position !== null) {
      if (module !== 'zielone_szkoly') {
        formik.setFieldValue('positions', formik.values.positions.filter(p => p.id !== position.id));
      } else {
        const { error } = await mutate(position.id);
        if (!error) {
          dispatch(updateOrder({ ...order, products: positions.filter(p => p.id !== position.id) }));
          setPosition(null);
          toast.success('Pozycja została usunięta');
        } else {
          toast.error('Wystąpił błąd');
        }
      }
    }
  };

  return (
    <>
      <Table size="small" sx={{ width: '100%' }}>
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell align="center">Nazwa</TableCell>
            <TableCell align="center">Wartość brutto</TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {module !== 'zielone_szkoly'
            ? formik ? formik.values.positions.map(row => <Row key={row.id} module={module} order={order} row={row} setPosition={setPosition} setOpenConfirmDialog={setOpen} setOpenEditModal={setOpenEditModal} showOptions={true} />
            ) : positions.map(row => <Row key={row.id} module={module} order={order} row={row} setPosition={setPosition} setOpenConfirmDialog={setOpen} setOpenEditModal={setOpenEditModal}/>)
            : positions.map(row => <Row key={row.id} module={module} order={order} row={row} setPosition={setPosition} setOpenConfirmDialog={setOpen} setOpenEditModal={setOpenEditModal} showOptions={true} />
            )}
        </TableBody>
      </Table>
      <ConfirmDialog open={open} setOpen={setOpen} onConfirm={handleDelete}>
        <Typography>
          Czy na pewno chcesz usunąć pozycje?
        </Typography>
      </ConfirmDialog>
      {openEditModal
        ? <EditPositionModal
          open={openEditModal}
          handleClose={() => setOpenEditModal(false)}
          position={position}
          order={order}
          formik={formik}
          module={module}
        />
        : null}
    </>
  );
};
